import React from "react";
import { Box } from "@mui/material";
import DocProgress from "../../../components/cases/documents/DocProgress";
import { Outlet, useOutletContext } from "react-router-dom";
const DocStatus = () => {
  const [data, handleRefresh, location] = useOutletContext();

  const path = location.pathname.split("/");
  return path[path?.length - 1] === "documents" ? (
    <Box component="div" className="doc-status">
      <DocProgress />
    </Box>
  ) : (
    <Outlet />
  );
};

export default DocStatus;
